import styled from '@emotion/styled';
import { breakpoints } from '~/theme/breakpoints';

export const PDPContent = styled.div(() => ({
    width: '100%',
    display: 'none',
    [breakpoints.sm]: {
        display: 'block',
    },
}));
